<script lang="ts" setup>
  import { ApiFlexError } from '@/services/api/api-error.ts';
  import { useAuthStore } from '@/stores/auth.ts';
  import { useThemeStore } from '@/stores/theme';
  import { onMounted, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  const route = useRoute();
  const router = useRouter();
  const authStore = useAuthStore();
  const themeStore = useThemeStore();
  const error = ref<Error>();

  async function login() {
    try {
      await authStore.loginAsync();
      const redirect = localStorage.getItem('redirect') ?? '/';
      localStorage.removeItem('redirect');
      await router.push(redirect);
    } catch (e) {
      console.log('login error', e);
      if (e instanceof ApiFlexError && e.value.resultCode == 401) {
        authStore.goLogin();
        return;
      }
      if (e instanceof Error) error.value = e;
    }
  }

  onMounted(() => {
    const token = route.query.token;
    if (token) {
      authStore.setToken(token as string);
    }
    if (authStore.token) {
      login();
      return;
    }
    const errorParam = route.query.error;
    if (errorParam) {
      console.log(errorParam);
      error.value = new Error(errorParam as string);
      router.push("/");
      return;
    }
    setTimeout(() => {
      authStore.goLogin();
    }, 500); // 로딩 화면이 너무 빨리 지나가는 걸 방지하기 위해 살짝 지연
  });
</script>

<template>
  <div
    class="flex items-center justify-center h-screen"
    :class="{
      'bg-slate-200': themeStore.theme == 'light',
      'bg-gray-800': themeStore.theme == 'dark',
    }">
    <div
      class="card w-72 bg-base-100 shadow-xl"
      :class="{
        'bg-base-100': themeStore.theme == 'light',
        'bg-slate-600': themeStore.theme == 'dark',
      }">
      <figure class="px-6 pt-8">
        <img
          alt=""
          src="../assets/images/time-management.svg" />
      </figure>

      <div
        v-if="!Boolean(error)"
        class="card-body items-center text-center">
        <h2 class="card-title">로그인중</h2>
        <p class="text-gray-400">잠시만 기다려주세요...</p>
        <div class="card-actions">
          <span class="loading loading-spinner bg-slate-200" />
        </div>
      </div>
      <div
        v-else
        class="card-body items-center text-center">
        <h2 class="card-title text-error">로그인 에러</h2>
        <p class="text-gray-400">
          내 정보를 불러오지 못했습니다.
          <br />
          먼저 구글 로그인을 해주세요.
        </p>
        <p class="text-2xl">😵</p>
      </div>
    </div>
  </div>
</template>
